import React from 'react'
import { Link } from 'react-router-dom'
import { useLanguage, LangToggle } from '../context/LanguageContext'

export default function LandingPage() {
  const { t } = useLanguage()

  return (
    <div className="landing-page">
      {/* Nav */}
      <div className="landing-nav">
        <div className="topbar-logo">
          <span style={{ color: '#E8610A', fontWeight: 900, fontSize: '1.1rem' }}>{t.appName} 🛡️</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <LangToggle />
          <Link to="/login" className="landing-login-btn">{t.loginBtn}</Link>
        </div>
      </div>

      {/* Hero */}
      <div className="landing-hero">
        <h1 className="landing-hero-title">{t.landingHero}</h1>
        <p className="landing-hero-sub">{t.landingHeroSub}</p>
        <Link to="/register" className="btn-full" style={{ maxWidth: 320, display: 'block', margin: '0 auto', textAlign: 'center', textDecoration: 'none' }}>
          {t.getStartedFree}
        </Link>
        <div className="landing-hero-login">
          <Link to="/login">{t.alreadyHaveAccount}</Link>
        </div>
      </div>

      {/* How it works */}
      <div className="landing-section">
        <h2 className="landing-section-title">{t.howItWorks}</h2>
        <div className="landing-steps">
          <div className="landing-step">
            <div className="landing-step-icon">📱</div>
            <div className="landing-step-num">1</div>
            <div className="landing-step-title">{t.step1Title}</div>
            <div className="landing-step-sub">{t.step1Sub}</div>
          </div>
          <div className="landing-step">
            <div className="landing-step-icon">🔒</div>
            <div className="landing-step-num">2</div>
            <div className="landing-step-title">{t.step2Title}</div>
            <div className="landing-step-sub">{t.step2Sub}</div>
          </div>
          <div className="landing-step">
            <div className="landing-step-icon">🔔</div>
            <div className="landing-step-num">3</div>
            <div className="landing-step-title">{t.step3Title}</div>
            <div className="landing-step-sub">{t.step3Sub}</div>
          </div>
        </div>
      </div>

      {/* Why Damanati */}
      <div className="landing-section">
        <h2 className="landing-section-title">{t.whyDamanati}</h2>
        <div className="landing-reasons">
          <div className="landing-reason">
            <span className="landing-reason-icon">📋</span>
            <span>{t.reason1}</span>
          </div>
          <div className="landing-reason">
            <span className="landing-reason-icon">⏰</span>
            <span>{t.reason2}</span>
          </div>
          <div className="landing-reason">
            <span className="landing-reason-icon">🧠</span>
            <span>{t.reason3}</span>
          </div>
          <div className="landing-reason">
            <span className="landing-reason-icon">🌐</span>
            <span>{t.reason4}</span>
          </div>
        </div>
      </div>

      {/* Pricing teaser */}
      <div className="landing-section">
        <div className="landing-pricing-teaser">
          <div className="landing-pricing-badge">{t.startingFrom}</div>
          <div className="landing-pricing-amount">9.99 <span className="landing-pricing-currency">{t.sarCurrency}</span></div>
          <div className="landing-pricing-period">{t.perMonthShort} {t.onlyText}</div>
          <Link to="/register" className="btn-full" style={{ maxWidth: 280, margin: '20px auto 0', display: 'block', textAlign: 'center', textDecoration: 'none' }}>
            {t.getStartedFree}
          </Link>
        </div>
      </div>

      {/* Footer */}
      <div className="landing-footer">
        <span style={{ color: 'var(--orange)', fontWeight: 700 }}>{t.appName} 🛡️</span>
        <span style={{ color: 'var(--ash)', fontSize: '0.8rem' }}>&copy; {new Date().getFullYear()}</span>
      </div>
    </div>
  )
}
